/* eslint-disable quotes */
/* eslint-disable max-len */
import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import { Redirect } from 'react-router-dom';
import PhoneInput from '../common/PhoneInput';
import BaseInput from '../common/BaseInput';
import BaseSelect from '../common/BaseSelect';
import AgentLockedOutConfirmation from './AgentLockedOutConfirmation';
import centerfieldIcon from '../images/cf-logo.svg';
import { getCities, getCountries, getStates, getPostalCode } from '../api';
import isSupervisor from '../util/isSupervisor';

export class AgentInfoVerification extends Component {
  state = {
    inputValidMap: this.props.inputValidMap,
    allFieldsValid: false,
    invalidFormSubmitted: false,
    showAddress: false,
    inputValues: {},
    countries: [],
    states: [],
    cities: [],
    kingstonZipCodes: []
  }

  componentDidMount = async () => {
    const countries = await getCountries();
    
    this.setState({ countries })
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {
      invalidFormSubmitted: nextInvalidFormSubmitted,
      inputValues: nextInputValues,
      countries: nextCountries,
      inputValidMap: nextInputValidMap
    } = nextState;
    const {
      invalidFormSubmitted: prevInvalidFormSubmitted,
      inputValues: prevInputValues,
      countries: prevCountries,
      inputValidMap: prevInputValidMap
    } = this.state;

    const { agentInfoVerificationSubmitted: nextAgentInfoVerificationSubmitted } = nextProps;
    const { agentInfoVerificationSubmitted: prevAgentInfoVerificationSubmitted } = this.props;

    const invalidFormSubmittedDiff = nextInvalidFormSubmitted !== prevInvalidFormSubmitted;
    const agentInfoVerificationSubmittedDiff = nextAgentInfoVerificationSubmitted !== prevAgentInfoVerificationSubmitted;
    const inputValuesDiff = nextInputValues !== prevInputValues;
    const countriesDiff = nextCountries !== prevCountries;
    const inputValidMap = nextInputValidMap !== prevInputValidMap;
    
    return invalidFormSubmittedDiff || agentInfoVerificationSubmittedDiff || inputValuesDiff || countriesDiff || inputValidMap;
  }

  formSubmit = (e) => {
    e.preventDefault();

    const {
      props: { user, actions: { postAgentVerificationInfoAction } },
      state: { allFieldsValid, inputValues } 
    } = this;

    const userID = isSupervisor(user);

    if (allFieldsValid) {
      const data = {
        inputValues, 
        userID
      }
      postAgentVerificationInfoAction(data);
    } else {
      // if fields are not all valid, set state to trigger error states of inputs
      this.setState({ invalidFormSubmitted: true });
    }
  }

  handleChange = async (value, inputKey, isValid) => {
    const { inputValidMap: oldInputValidMap } = this.state;
    const newInputValidMap = new Map(oldInputValidMap);

    newInputValidMap.set(inputKey, isValid);
    // reset zipCode validation when country/region is changed
    // zip code to not show for Jamaica
    
    if(inputKey === 'countryInput') {
      const states = await getStates(value);

      newInputValidMap.set('stateInput', false);

      this.setState(prevState => ({
        states,
        inputValidMap: newInputValidMap,
        inputValues: {
          ...prevState.inputValues,
        }
      }));
    }

    if(inputKey === 'stateInput') {
      const cities = await getCities(value);
      
      if(value === 'KGN') {
        
        const kingstonZipCodes = await getPostalCode(value);

        newInputValidMap.set('zipcodeInput', false);

        this.setState({ kingstonZipCodes });
      } 
        
      this.setState({ cities });

    } else if(inputKey === 'stateInput' && value !== 'KGN' && this.state.inputValues.countryInput === 'JAM') {
      newInputValidMap.set('zipcodeInput', true);
    }
    
    if(inputKey === 'countryInput' && value === 'JAM') {
      newInputValidMap.set('stateInput', false);
      newInputValidMap.set('zipcodeInput', true);
    } else if(inputKey === 'countryInput' && value === 'USA') {      
      newInputValidMap.set('stateInput', false);
      newInputValidMap.set('zipcodeInput', false);
    }
    
    
    let allFieldsValid = true;
    for (const [, isValid] of newInputValidMap) {
      if (!isValid) {
        allFieldsValid = false;
        break;
      }
    }
    
    // update internal state (validity)
    this.setState(prevState => ({
      inputValidMap: newInputValidMap,
      allFieldsValid,
      inputValues: {
        ...prevState.inputValues,
        [inputKey]: value
      }
    }));
  }

  render() {
    let {
      props: { 
        emailValidationRules,
        phoneValidationRules,
        countryValidationRules,
        addressValidationRules,
        cityValidationRules,
        zipCodeValidationRules,
        agentLockedOut,
        agentInfoVerificationSubmitted,
        lockedOutShowAgentVerificationForm,
        alternateLockedOut
       },
      state: {
        invalidFormSubmitted,
        inputValues,
        countries,
        states,
        cities,
        kingstonZipCodes
      }
    } = this;
    
    const isUSA = inputValues.countryInput === 'USA';
    const isJamaica = inputValues.countryInput === 'JAM';
    
    return (
      <div className="AIV">
        { agentInfoVerificationSubmitted && !agentLockedOut && !alternateLockedOut ? 
          <Redirect to={{pathname: '/Schedules'}}  /> : "" 
        }
        { !agentInfoVerificationSubmitted ?
        <Fragment>
          <div className="AIV__hdr">
            <img src={centerfieldIcon} alt="centerfield-icon" className="AIV__hdr-logo" />
            <div className="AIV__hdr-text">
              { (agentLockedOut || lockedOutShowAgentVerificationForm) ? 
              "Incomplete Verification" 
              : "Verify your Contact Information" }
            </div>
          </div>
          { (agentLockedOut || lockedOutShowAgentVerificationForm) ? 
            <div className="AIV__title lockedout">
              Your Agent Portal access is locked due to an incomplete personal verification process.
            </div>
          :
            <div className="AIV__title">
              <span className={invalidFormSubmitted ? 'AIV__title--error' : ''}>
                Please verify your contact information to access your account.
              </span>
              <br/>
              Any updates will be saved in Ultipro
            </div>
          }
          <form className="AIV__form" noValidate autoComplete="nope" onSubmit={this.formSubmit}>
            { (agentLockedOut || lockedOutShowAgentVerificationForm) && (
              <div className="AIV__subtitle">
                To access your account, restart the verification process by completing the information below.
            </div>
            )}
            <PhoneInput
              inputKey={'phoneInput'}
              placeholder="Phone Number"
              // label="Phone Number"
              errorMessage={'Phone Number is required'}
              eventHandler={this.handleChange}
              invalidFormSubmitted={ invalidFormSubmitted }
              validationRules={phoneValidationRules}
              inputClassName={'formInput__phone'}
              requiredText={false}
            />
            <BaseInput 
              inputKey={'emailInput'}
              type="tel"
              placeholder="Email Address"
              // label="Personal Email"
              errorMessage={'Email is required'}
              eventHandler={this.handleChange}
              invalidFormSubmitted={ invalidFormSubmitted }
              validationRules={emailValidationRules}
              inputClassName={'formInput__email'}
              requiredText={false}
            />
            <BaseSelect
              inputKey={'countryInput'}
              placeholder="- Select Country -"
              placeholderSmall='Country'
              // label="Country/Region"
              errorMessage={'Country is required'}
              options={countries}
              value={''}
              eventHandler={this.handleChange}
              invalidFormSubmitted={ invalidFormSubmitted }
              validationRules={countryValidationRules}
              inputClassName={'formInput__country'}
              requiredText={false}
              isValid={this.state.inputValidMap.get('countryInput')}
            />
            { inputValues.countryInput && (
              <div>
                <BaseInput 
                  inputKey={'addressInput'}
                  type="text"
                  placeholder="Street Address"
                  // label="Street Address"
                  errorMessage={'Address is required'}
                  eventHandler={this.handleChange}
                  invalidFormSubmitted={ invalidFormSubmitted }
                  validationRules={addressValidationRules}
                  inputClassName={'formInput__address'}
                  requiredText={false}
                />
                <BaseInput 
                  inputKey={'aptInput'}
                  type="text"
                  placeholder="Apartment, suite, unit..."
                  notRequired={true}
                  eventHandler={this.handleChange}
                  invalidFormSubmitted={ invalidFormSubmitted }
                  inputClassName={'formInput__apt'}
                  requiredText={false}
                />
                <div className={`AIV__stateCity-wrap ${isJamaica ? 'AIV__jamaica-wrap' : ''}`}>
                  { isJamaica ?
                    <BaseSelect
                      inputKey={'cityInput'}
                      placeholder="- Select City -"
                      placeholderSmall='City'
                      // label="City"
                      errorMessage={'City is required'}
                      options={cities}
                      value={''}
                      isStates={true}
                      eventHandler={this.handleChange}
                      invalidFormSubmitted={ invalidFormSubmitted }
                      validationRules={countryValidationRules}
                      disabled={cities.length < 1}
                      inputClassName={'formInput__city'}
                      requiredText={false}
                    />
                  :
                    <BaseInput 
                      inputKey={'cityInput'}
                      type="text"
                      placeholder="City"
                      // label="City"
                      errorMessage={'City is required'}
                      eventHandler={this.handleChange}
                      invalidFormSubmitted={ invalidFormSubmitted }
                      validationRules={cityValidationRules}
                      inputClassName={'formInput__city'}
                      requiredText={false}
                    />
                  }
                  <BaseSelect
                    inputKey={'stateInput'}
                    placeholder="- Select State -"
                    placeholderSmall='State'
                    // label="State/Province/Region"
                    errorMessage={'State is required'}
                    options={states}
                    value={this.state.inputValues.stateInput}
                    eventHandler={this.handleChange}
                    invalidFormSubmitted={ invalidFormSubmitted }
                    validationRules={countryValidationRules}
                    inputClassName={'formInput__state'}
                    requiredText={false}
                  />
                </div>
                { isUSA && (
                  <BaseInput 
                    inputKey={'zipcodeInput'}
                    type="tel"
                    placeholder="Zip Code"
                    // label="Zip Code"
                    errorMessage={'Zip Code is required'}
                    maxLength={5}
                    minLength={5}
                    stripAlphaChars
                    eventHandler={this.handleChange}
                    invalidFormSubmitted={ invalidFormSubmitted }
                    validationRules={zipCodeValidationRules}
                    inputClassName={'formInput__zipcode'}
                    requiredText={false}
                  />
                )}
                { (isJamaica && inputValues.stateInput === 'KGN' && this.state.inputValidMap.get('stateInput')) && (
                  <BaseSelect
                    inputKey={'zipcodeInput'}
                    placeholder="- Select Postal District -"
                    placeholderSmall='Postal District'
                    // label="Postal District"
                    errorMessage={'Postal District is required'}
                    options={kingstonZipCodes}
                    value={''}
                    eventHandler={this.handleChange}
                    invalidFormSubmitted={ invalidFormSubmitted }
                    validationRules={countryValidationRules}
                    disabled={kingstonZipCodes.length < 1}
                    inputClassName={'formInput__state'}
                    requiredText={false}
                  />
                )}
              </div>
            )}
            <div className={`AIV__button-wrap ${agentLockedOut || lockedOutShowAgentVerificationForm ? 'AIV__button-wrap-flex' : ''}`}>
              { (agentLockedOut || lockedOutShowAgentVerificationForm) && (
                <div className="AIV__noc-text">
                  Please contact <a href='mailto:noc@centerfield.com'>noc@centerfield.com</a> if you are experiencing
                  <br></br>
                  problems with your account. 
                </div>
              )}
              <button 
                type="submit"
                onClick={this.formSubmit}
                className={`AIV__submit${inputValues.countryInput ? '' : '--disabled'}`}
                disabled={!inputValues.countryInput}
              >
                Submit
              </button>
            </div>

          </form>
          </Fragment>
        :
          <AgentLockedOutConfirmation />
        }
      </div>
    );
  }
}

function mapStateToProps({
  agentInfoVerification: { 
    inputValidMap,
    emailValidationRules,
    phoneValidationRules,
    countryValidationRules,
    addressValidationRules,
    cityValidationRules,
    zipCodeValidationRules,
    agentLockedOut,
    alternateLockedOut,
    showTwoStepVerificationPromptModal,
    agentInfoVerificationSubmitted,
    lockedOutShowAgentVerificationForm
  },
  common: { user }
}) {
  return {
    inputValidMap,
    emailValidationRules,
    phoneValidationRules,
    countryValidationRules,
    addressValidationRules,
    cityValidationRules,
    zipCodeValidationRules,
    agentLockedOut,
    alternateLockedOut,
    showTwoStepVerificationPromptModal,
    agentInfoVerificationSubmitted,
    user,
    lockedOutShowAgentVerificationForm
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AgentInfoVerification);



// WEBPACK FOOTER //
// ./src/features/agent-info-verification/components/AgentInfoVerification.js